<template>
  <div>
    <shell>
      <div class="container m-auto">
        <div class="sm:w-full lg:w-1/2 pb-6 m-auto px-2">

          <div v-if="isEmailVerified" class="bg-full-blue text-white py-4 px-2 mb-4 text-sm rounded">
            <p>Your email is verified!</p>
          </div>
          <h2 class="pb-12 text-3xl font-bold">{{title}}</h2>

          <div v-if="isDescriptionVisible" class="pb-8">
            <p class="leading-normal mb-4 text-base"><a target="_blank" href="https://www.tatatap.com/about">I&rsquo;m</a> dedicated to helping you find the mind in your fingers.</p>
            <p class="leading-normal mb-4 text-base">In addition to <a href="https://www.tatatap.com/how-to">detailed guides</a> covering all aspects of the /tap functionality, support is only an email away at <a href="mailto:hello@tatatap.com">hello@tatatap.com</a></p>

          </div>
          <div v-if="member.email_verified === false" class="px-4 py-2 mb-6 bg-full-blue rounded">
            <div class="bg-full-blue text-white text-base leading-normal">
              Please verify your email. Once that&rsquo;s done, you can start collecting notes!
            </div>
          </div>
          <plan-options :member="member" />
        </div>


      </div>
    </shell>
  </div>
</template>

<script>
 import {mapState, mapActions} from 'vuex';
 import Shell from '@/components/Shell'
 import PlanOptions from '@/components/PlanOptions'
 export default {
   data () {
     return {
       
     }
   },

   components: { Shell, PlanOptions },

   async created () {
     
   },

   computed: {
     ...mapState({
       member: state => state.member
     }),
     title () {
       const planName = this.member.plan_name;

       if (!planName) {
         return 'Buy /tap, Get More Than Software';
       }

       return ({
         'year_basic': 'Subscription',
         'month_basic': 'Subscription',
         'free': 'Buy /tap, Get More Than Software',
         })[planName];
     },

     isEmailVerified () {
       return this.$route.query.emailverified === 'true';
     },

     isDescriptionVisible () {
       const planName = this.member.plan_name;

       if (!planName) {
         return true;
       }

       return ['free'].indexOf(planName) !== -1
     }
     
   },

   methods: {
     ...mapActions(['upgradeSub', 'downgradeSub'])
   }
 };
</script>

